import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const CopyTicketSuccess = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 16}
        height={size ?? 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4 1.33334H8.6C6.6793 1.33334 5.71167 1.97027 5.42923 3.49261C5.32764 4.04018 5.79499 4.50001 6.3519 4.50001H7.4C10.2 4.50001 11.5 5.80001 11.5 8.60001V9.64811C11.5 10.205 11.9598 10.6724 12.5074 10.5708C14.0297 10.2883 14.6667 9.32071 14.6667 7.40001V4.60001C14.6667 2.26668 13.7333 1.33334 11.4 1.33334Z"
          fill={color}
        />
        <path
          d="M7.4 5.33334H4.6C2.26666 5.33334 1.33333 6.26668 1.33333 8.60001V11.4C1.33333 13.7333 2.26666 14.6667 4.6 14.6667H7.4C9.73333 14.6667 10.6667 13.7333 10.6667 11.4V8.60001C10.6667 6.26668 9.73333 5.33334 7.4 5.33334ZM8.19333 9.10001L5.72 11.5733C5.62666 11.6667 5.50666 11.7133 5.37999 11.7133C5.25333 11.7133 5.13333 11.6667 5.03999 11.5733L3.79999 10.3333C3.61333 10.1467 3.61333 9.84668 3.79999 9.66001C3.98666 9.47334 4.28666 9.47334 4.47333 9.66001L5.37333 10.56L7.51333 8.42001C7.7 8.23334 7.99999 8.23334 8.18666 8.42001C8.37333 8.60668 8.37999 8.91334 8.19333 9.10001Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CopyTicketSuccess;
